import React from 'react'
import {
  FeedDetailListBlock,
  FeedDetailContent,
  FeedCotentImg,
  FeedTimeBar,
  FeedTimeText,
  AnimationBlock,
} from './style'
import FeedDetailTop from 'components/presenters/feed/detail/FeedDetailTop'
import FeedDetailFooter from 'components/presenters/feed/detail/FeedDetailFooter'
import appInfoContainer from 'auth/appInfoContainer'
import LottieLoader from 'components/containers/common/LottieLoader'
import ProofTimeStamp from '../ProofTimeStamp'

const FeedItem = ({
  feedItem,
  userInfo,
  addLikeRequest,
  deleteLikeRequest,
  handleBottomModalState,
  openBottomInputForm,
  commentVisible,
  commentList,
  currentFeedNo,
  handleCommentBottomModal,
  loadNextComments,
  handleDoubleClick,
  insertedCommentList,
  isLikeAnimation,
  lottieOptions,
  onClickComment,
  onReplyClick,
  handleShowReply,
  replyList,
  handleNextLoadReply,
  handleReplyDeleteBottomModal,
  feedDescLimit,
  handleClickMore,
  index,
  showMoreFeedNoList,
  isDetailItem,
}) => {
  const imagePath = `${appInfoContainer.imagePath}/task_img/${feedItem['proof'][0]}`

  if (!feedItem) return null
  return (
    <FeedDetailListBlock id={`feed-list-item-${feedItem['no']}`}>
      <FeedDetailTop
        feedItem={feedItem}
        userInfo={userInfo}
        handleBottomModalState={handleBottomModalState}
      />
      <FeedDetailContent onClick={() => handleDoubleClick(feedItem)}>
        <FeedCotentImg src={imagePath} />
        {isLikeAnimation && currentFeedNo === feedItem['task_no'] ? (
          <AnimationBlock>
            <LottieLoader
              lottieOptions={lottieOptions}
              style={{ width: 'calc(100vw * (201 / 375))', height: 'calc(100vw * (169 / 375))' }}
            />
          </AnimationBlock>
        ) : null}
      </FeedDetailContent>
      <FeedDetailFooter
        feedItem={feedItem}
        userInfo={userInfo}
        addLikeRequest={addLikeRequest}
        deleteLikeRequest={deleteLikeRequest}
        openBottomInputForm={openBottomInputForm}
        commentList={commentList}
        currentFeedNo={currentFeedNo}
        handleCommentBottomModal={handleCommentBottomModal}
        loadNextComments={loadNextComments}
        insertedCommentList={insertedCommentList}
        isLikeAnimation={isLikeAnimation}
        lottieOptions={lottieOptions}
        onClickComment={onClickComment}
        onReplyClick={onReplyClick}
        handleShowReply={handleShowReply}
        replyList={replyList}
        handleNextLoadReply={handleNextLoadReply}
        handleReplyDeleteBottomModal={handleReplyDeleteBottomModal}
        feedDescLimit={feedDescLimit}
        handleClickMore={handleClickMore}
        index={index}
        showMoreFeedNoList={showMoreFeedNoList}
        isDetailItem={isDetailItem}
      />
    </FeedDetailListBlock>
  )
}

export default FeedItem
